import { AuditService } from "@app/services/http/audit.service";
import { ColumnConfig, DateColumnConfig } from "@bryntum/grid-thin";
import moment from "moment";

export class BaseAuditRenderer {
  auditColumns: ColumnConfig[] | DateColumnConfig[] = [
    {
      field: "name",
      text: "Name",
      width: "200px",
      renderer: ({ value, record, cellElement }) => {
        console.log("Rendering record", record);
        if (record.get("wasChanged")) {
          console.log("Detected changed row", record);
          cellElement.style.background = `#f2faa4`;
        }
        return value;
      }
    },
    {
      field: "value",
      text: "Value",
      flex: 1,
      type: "column",
      htmlEncode: false,
      renderer: ({ value, record, cellElement }) => {
        if (record.get("wasChanged")) {
          cellElement.style.background = `#f2faa4`;
        }

        if (typeof value === "string") {
          if (value.startsWith("[") && value.endsWith("]")) {
            // Extracting the elements from the string
            let elements = value.slice(1, -1).split(", ");

            // Creating audit-jump-buttons for each element
            return elements
              .map((val) =>
                val.startsWith("...")
                  ? `<audit-jump-button link-string="${val}"></audit-jump-button>`
                  : val
              )
              .join("");
          } else if (value.startsWith("...")) {
            return `<audit-jump-button link-string="${value}"></audit-jump-button>`;
          }
        }
        return value;
      }
    }
  ];

  constructor(
    public auditService: AuditService,
    public auditType: string
  ) {}

  getAudit(
    snapshotId: string,
    entityId: string,
    auditGrid: any,
    displayedValues: string[] = []
  ) {
    console.log("Init with snapshot: ", snapshotId, entityId);
    this.auditService
      .querySnapshot(entityId, this.auditType, snapshotId, 0, 100)
      .then((result) => {
        console.log("Snapshot result", result);
        let gridData = Object.entries(result.stateProperties).map(
          ([key, value]) => {
            return { name: key, value: value, wasChanged: false };
          }
        );
        let sortedGridData = gridData
          .filter((item) => displayedValues.includes(item.name)) // Filter out the non-matching items
          .map((item) => {
            let parsedDate = moment(item.value, moment.ISO_8601, true);

            // Check if the parsed date is valid
            if (parsedDate.isValid()) {
              // Format it to the desired string format
              item.value = parsedDate.format("DD/MM/YYYY HH:mm:ss Z");
            }

            //if item.name is in item.stateProperties string array then set changed to true
            if (result.changed.includes(item.name)) {
              item.wasChanged = true;
            }
            return item;
          })
          .sort(
            (a, b) =>
              displayedValues.indexOf(a.name) - displayedValues.indexOf(b.name)
          ); // Sort based on the order in displayedValues

        console.log("Mapped grid data", gridData);
        console.log("Sorted grid Data", sortedGridData);
        auditGrid.addRow(sortedGridData);
      });
  }
}
